import React from 'react'
import Reporting from 'src/app/Reporting/Reporting'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { reportingRouteProps } from 'src/navigation/routeProps'

const ReportingAppRoute: AppRoute = {
  id: AppLocation.Reporting,
  routeProps: reportingRouteProps,
  component: <Reporting />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ReportingAppRoute
